import React, { useContext, useState, useEffect } from "react";
import car1 from "../../assets/car1.webp";
import car2 from "../../assets/car2.webp";
import car3 from "../../assets/car23.png";
import car4 from "../../assets/car4.png";
import coimbatore_bg from "../../assets/coimbatore_bg.png";
import { motion, AnimatePresence } from "framer-motion";
import { WebsiteContext } from "../../context/AppContext";
import "../../styles/homeComponent.css";
import { useNavigate } from "react-router-dom";

const carData = [
  { id: 0, src: car1, label: "SEDAN" },
  { id: 1, src: car2, label: "SUV" },
  { id: 2, src: car3, label: "INNOVA" },
  { id: 3, src: car4, label: "Family Trip" },
];

const HomeComponent = () => {
  const [activeCar, setActiveCar] = useState(0);
  const navigate = useNavigate();
  const { isMobileView } = useContext(WebsiteContext);

  const handleCars = (id) => setActiveCar(id);

  const handleBookNow = () => {
    navigate("/book-now");
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  return (
    <div className={`hero_container ${isMobileView ? "mobile" : ""}`}>
      {/* Immersive Background Layer */}
      <div
        className="hero_background"
        style={{ backgroundImage: `url(${coimbatore_bg})` }}
      >
        <div className="hero_overlay"></div>
      </div>

      {/* Foreground Content */}
      <div className="hero_content">
        <motion.div
          className="hero_typography"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h1 className="hero_title_lead">The Best Travels in</h1>
          <h2 className="hero_title_main">Coimbatore</h2>
        </motion.div>

        {/* Dynamic Car Showcase */}
        {!isMobileView && (
          <div className="hero_car_display">
            <AnimatePresence mode="wait">
              <motion.img
                key={activeCar}
                src={carData[activeCar].src}
                alt={carData[activeCar].label}
                className={`hero_car_image car_${activeCar}`}
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
              />
            </AnimatePresence>
          </div>
        )}

        {/* Interactive Controls */}
        <div className="hero_controls">
          <div className="hero_car_selectors">
            {carData.map((car) => (
              <button
                key={car.id}
                onClick={() => handleCars(car.id)}
                className={`car_selector_pill ${activeCar === car.id ? "active" : ""}`}
              >
                {car.label}
              </button>
            ))}
          </div>

          <motion.button
            onClick={handleBookNow}
            className="hero_book_btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span>Book Now!</span>
          </motion.button>
        </div>
      </div>
      <div className="hero_bottom_divider"></div>
    </div>
  );
};

export default HomeComponent;
